import { ValueOf } from 'types'

export type RtmStorageKeyFormat = `rtm:${string}`

export const StorageKey: Record<string, RtmStorageKeyFormat> = {
  QueueHealthTableRowHeight: 'rtm:queueHealthTableRowHeight',
  AdditionalFilters: 'rtm:additionalFilters',
  LastRefreshSlackUserGroups: 'rtm:lastRefreshSlackUserGroups',
  UrlStateMap: 'rtm:urlStateMap',
} as const

export type StorageKey = ValueOf<typeof StorageKey>
